export default {
    callGetItemsCart: (state) => !state.calledGetItemsCart,
    listCartWithAdditionalProducts : (state) => {
        return state?.itemsCart?.list
            ?.filter(el => {
                el.additional_products = []
                if(el.has_childs_additionals == true) {
                    el.additional_products.push(
                        state.itemsCart.list.filter(p => p.uuid_item_father_cart == el.uuid)
                    )
                    return el
                }
            })

    },
    containsAdditionalProductsInCart : (state) => {
        return !!state?.itemsCart?.list?.find(el => el.has_childs_additionals == true)
    }
}
